import { Combobox, ComboboxProps, Input, InputBase, ScrollArea, useCombobox } from "@mantine/core";
import { Path } from "../../types/pathType";

interface IMcComboBox<T> extends ComboboxProps {
  onChange: (item: T | null) => void;
  options: T[];
  displayProperty: Path<T>;
  currentValue: T | null;
  placeholder?: string;
}

export const McCombobox = <T,>({
  options,
  onChange,
  displayProperty,
  currentValue,
  placeholder,
  ...props
}: IMcComboBox<T>) => {
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const doSelect = (option: T) => {
    combobox.closeDropdown();
    onChange(option);
  };

  return (
    <Combobox store={combobox} {...props}>
      <Combobox.Target>
        <InputBase
          component="button"
          type="button"
          pointer
          rightSection={<Combobox.Chevron />}
          rightSectionPointerEvents="none"
          onClick={() => combobox.toggleDropdown()}
        >
          {currentValue != null && getNestedValue(currentValue, displayProperty) != null ? (
            String(getNestedValue(currentValue, displayProperty))
          ) : (
            <Input.Placeholder>{placeholder ?? ""}</Input.Placeholder>
          )}
        </InputBase>
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options>
          <ScrollArea.Autosize type="scroll" mah={300}>
            {options.map((option, index) => {
              const display = getNestedValue(option, displayProperty);
              const strDisplay = String(display);
              const optionElement = (
                <Combobox.Option key={index} value={strDisplay} onClick={() => doSelect(option)}>
                  {strDisplay}
                </Combobox.Option>
              );

              return optionElement;
            })}
          </ScrollArea.Autosize>
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
};

const getNestedValue = <T, TValue>(obj: T, path: Path<T, TValue>): TValue | null => {
  const parts = path.split(".");
  let result: any = obj;

  for (let i = 0; i < parts.length; i++) {
    if (result == null) {
      return null;
    }

    result = result[parts[i]];
  }

  return result;
};
